import React, {useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {useInitiateSiteSwitchLogMutation, useNavigateToClassicCastleMutation, useValidateSSOMutation} from '../../features/authentication/authApiSlice';
import { setCredentials } from '../../features/authentication/authSlice';
import { useDispatch } from 'react-redux';
import { getTimezoneOffset } from '../../utils/Timezoneoffset';

export default function Index() {
  const navigate = useNavigate();
  const [validateSSO] = useValidateSSOMutation();
  const [navToClassic] = useNavigateToClassicCastleMutation();
  const [initialiseSiteSwitchLog] = useInitiateSiteSwitchLogMutation();
  const dispatch = useDispatch();
  const reWriteUrl = useRef('');
  const ValidateSSOAsync = async() => {
    try {
      let tzo = await getTimezoneOffset();
      const authResponse = await validateSSO({ TimeZoneOffset: tzo }).unwrap();
      if(authResponse?.isSuccess){
        dispatch(
          setCredentials({
            accessToken: authResponse.accessToken
          })
        );
        
        if (authResponse.redirectUrl){
          await redirectToClassic(authResponse);
        }else {
          navigate('/dashboard');
        }
        
        return;
      }
      
      navigate('/login', {
        state: { nycSsoResponse: authResponse?.reason},
      });

    } catch (ex) {
      console.log('Exception',ex);
      navigate('/login');
    }
  };

  useEffect(() => {
    ValidateSSOAsync(); 
  }, []);

  const redirectToClassic = async(authResponse) => {
    const response = await navToClassic({
      reWriteUrl: authResponse.redirectUrl,
      selectedCenter: authResponse.redirectUrl.includes('AdminHome') ? 'AdminHome' : authResponse.redirectUrl.includes('TeacherHome') ? 'TeacherHome' : 'StudentHome'
    });
      
    if (response.error) {
      navigate('/login', {
        state: { nycSsoResponse: response.error.data.error},
      });
    } else {
      reWriteUrl.current = response.data.returnUrl;
      await handleSiteSwitchLog();
    }
  };

  const handleSiteSwitchLog = async() => {
    try{
      var response = await initialiseSiteSwitchLog();
      window.location.href = reWriteUrl.current + '&logId='+response.data;
    }catch(ex){
      console.log(ex); 
    }
  };

  return (
    <>Redirecting...</>
  );
}
